
    <div class="po-row">
        <po-info p-label="ID" class="po-md-3" [p-value]="databaseItem.id"></po-info>
        <po-tag p-label="Status" class="po-md-3" p-orientation="vertical" [p-type]="databaseItem.statusType" [p-value]="databaseItem.deployStatsDataResume"></po-tag>
        <po-info p-label="Expiração (dias)" class="po-md-2" [p-value]="databaseItem.remainingTime" ></po-info>
        <po-info p-label="Software" class="po-md-2" [p-value]="databaseItem.softwareType"></po-info>
    </div>

    <br>

    <div class="po-row" *ngIf="databaseItem.kind !== 'database'">
        <po-info p-label="Database IP" class="po-md-2" [p-value]="databaseItem.dbipporta" ></po-info>
        <po-info p-label="Username" class="po-md-3" [p-value]="databaseItem.username" ></po-info>
        <po-info p-label="DBAccess IP" class="po-md-2" [p-value]="databaseItem.dbaccess" ></po-info>
        <po-info p-label="DB Alias" class="po-md-2" [p-value]="databaseItem.alias" ></po-info>
        <po-info p-label="DBAPI:" class="po-md-2" p-value="Baixar versão atual" p-url="https://arte.engpro.totvs.com.br/engenharia/devops/artefatos/dbapi-esp-dbaccess/dbapi-esp-dbaccess.zip" ></po-info>
    </div>

    <br>

    <div class="po-row">
      <po-info p-label="Proprietário: " class="po-md-2" [p-value]="databaseItem.owner" ></po-info>
      <po-info p-label="Usuários compartilhados" class="po-md-7" [p-value]="databaseItem.shared" ></po-info>
      <po-info *ngIf="databaseItem.active === true" p-label="Criado em: " class="po-md-3" [p-value]="databaseItem.createdAt" ></po-info>
      <po-info *ngIf="databaseItem.active === false" p-label="Deletado em: " class="po-md-3" [p-value]="databaseItem.updatedAt" ></po-info>
    </div>

    <br>

    <div *ngIf="databaseItem.kind === 'database'">
        <po-accordion>
            <po-accordion-item p-label="DBAccess">
                <div class="po-row">
                    <po-info p-label="DBAccess IP" class="po-md-3" [p-value]="databaseItem.dbaccess" ></po-info>
                    <po-info p-label="Alias" class="po-md-3" [p-value]="databaseItem.alias" ></po-info>
                    <po-info p-label="DBApi:" class="po-md-3" p-value="Baixar versão atual" p-url="https://arte.engpro.totvs.com.br/engenharia/devops/artefatos/dbapi-esp-dbaccess/dbapi-esp-dbaccess.zip" ></po-info>
                </div>
            </po-accordion-item>
            <po-accordion-item p-label="Database">
                <div class="po-row">
                    <po-info *ngIf="databaseItem.metadata?.host" p-label="Host" class="po-md-3" [p-value]="databaseItem.metadata.host"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.port" p-label="Porta" class="po-md-2" [p-value]="databaseItem.metadata.port"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.user" p-label="Usuário" class="po-md-3" [p-value]="databaseItem.metadata.user"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.pass" p-label="Senha" class="po-md-3 hiddenPassword" [p-value]="databaseItem.visualPassword" title="click to show password" (click)="displayPassword(databaseItem)"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.databaseName" p-label="Database Name" class="po-md-3" [p-value]="databaseItem.metadata.databaseName"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.instanceName" p-label="Instance Name" class="po-md-3" [p-value]="databaseItem.metadata.instanceName"></po-info>
                    <po-info *ngIf="databaseItem.metadata?.databaseType" p-label="Database Type" class="po-md-3" [p-value]="databaseItem.metadata.databaseType"></po-info>
                </div>
            </po-accordion-item>
        </po-accordion>
    </div>